export default "__VITE_ASSET__8adce83b__"